import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SignInResponse } from '../../models/response/sign_in_response';
import { SignInRequest } from '../../models/request/sign_in_request';

interface UserState {
    signInResponse: any;
    loading: boolean;
    error: string | null;
    isAuthenticated: boolean;
    authLoading: boolean;
    signUpResponse: any;
    emailSendResponse: any;
    resetResponse: any;
}

const initialState: UserState = {
    signInResponse: null,
    loading: false,
    error: null,
    isAuthenticated: false,
    authLoading: false,
    signUpResponse: null,
    emailSendResponse: null,
    resetResponse: null,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        submitUserRequest(state, action: PayloadAction<SignInRequest>) {
            state.loading = true;
            state.error = null;
            state.isAuthenticated = false;
        },
        submitUserSuccess(state, action: PayloadAction<SignInResponse>) {
            state.loading = false;
            state.signInResponse = action?.payload;
            state.error = null;
            state.isAuthenticated = true;
        },
        submitUserFailure(state, action: PayloadAction<any>) {
            state.loading = false;
            state.error = action.payload;
            state.isAuthenticated = false;
        },
        logoutUserRequest(state) {
            state.authLoading = true;
        },
        logoutUserSuccess(state, action: PayloadAction<any>) {
            state.authLoading = false;
            state.isAuthenticated = false;
            localStorage.removeItem('user');
            localStorage.setItem('isAuthenticated', 'false');
            window.location.href = '/';
        },
        logoutUserFailure(state, action: PayloadAction<any>) {
            state.authLoading = false;
        },
        signUpUserRequest(state, action: PayloadAction<any>) {
            state.loading = true;
        },
        signUpUserSuccess(state, action: PayloadAction<any>) {
            state.loading = false;
            state.signUpResponse = action?.payload;
        },
        signUpUserFailure(state, action: PayloadAction<any>) {
            state.loading = false;
            state.error = action.payload;
        },
        resetRequest(state, action: PayloadAction<any>) {
            state.loading = true;
        },
        resetSuccess(state, action: PayloadAction<any>) {
            state.loading = false;
            state.emailSendResponse = action?.payload;
        },
        resetFailure(state, action: PayloadAction<any>) {
            state.loading = false;
            state.error = action.payload;
        },
        resetPasswordRequest(state, action: PayloadAction<any>) {
            state.loading = true;
        },
        resetPasswordSuccess(state, action: PayloadAction<any>) {
            state.loading = false;
            state.resetResponse = action?.payload;
        },
        resetPasswordFailure(state, action: PayloadAction<any>) {
            state.loading = false;
            state.error = action.payload;
        }
    },
});

// Export actions
export const {
    submitUserRequest,
    submitUserSuccess,
    submitUserFailure,
    logoutUserRequest,
    logoutUserSuccess,
    logoutUserFailure,
    signUpUserRequest,
    signUpUserSuccess,
    signUpUserFailure,
    resetRequest,
    resetSuccess,
    resetFailure,
    resetPasswordRequest,
    resetPasswordSuccess,
    resetPasswordFailure,
} = userSlice.actions;

// Export reducer
export default userSlice.reducer;
